import { Dispatch } from 'redux';

import { updateLoadingLogin, updateLoginError } from 'connect/actions';
import { RequestAppointment } from 'connect/saga/handlers/appointment/request-appointment';
import { CreatePartnerPatient } from 'connect/saga/handlers/partner/create-partner-patient';
import { RequestPatientPhoneVerification, VerifyPatientPhone } from 'connect/saga/handlers/patient/unverified-phone';
import { UpdatePatientDetails } from 'connect/saga/handlers/patient/update-details';
import { RequestEmailVerification, RequestPhoneVerification, RequestPhoneVerificationSmsStatus, VerifyEmail, VerifyPhone } from 'connect/saga/handlers/patient/verify';
import { ValidateReservedAppointmentSlot } from 'connect/saga/handlers/reserved-appointment-slot/validate-slot';
import { Authenticate } from 'connect/saga/handlers/user/authenticate';

import { PatientV4Login } from 'connect/saga/handlers/user/patient-v4-login';
import { Signup } from 'connect/saga/handlers/user/signup';

export const resetCheckoutData = (dispatch: Dispatch) => {
  dispatch(updateLoadingLogin(false));
  dispatch(updateLoginError(null));

  dispatch(Authenticate.reset());
  dispatch(Signup.reset());
  dispatch(CreatePartnerPatient.reset());

  dispatch(UpdatePatientDetails.reset());

  dispatch(RequestEmailVerification.reset());
  dispatch(VerifyEmail.reset());
  dispatch(RequestPhoneVerification.reset());
  dispatch(RequestPhoneVerificationSmsStatus.reset());
  dispatch(VerifyPhone.reset());
  dispatch(RequestPatientPhoneVerification.reset());
  dispatch(VerifyPatientPhone.reset());

  dispatch(ValidateReservedAppointmentSlot.reset());
  dispatch(RequestAppointment.reset());

  dispatch(PatientV4Login.reset());
};
